import { Heading, Button } from '@flixbus/honeycomb-react';
import VoucherList from './VoucherList';
import { BatchUpdateProvider } from '../../context/VoucherBatchUpdateProvider';
import { VoucherListProvider } from '../../context/VoucherListProvider';

import styles from './dashboard.module.scss';
import { Icon, IconChat } from '@flixbus/honeycomb-icons-react';

const Dashboard = () => {
  const surveyUrl = 'https://surveys.cro.flix.tech/s/cm9a274480gz6ma01k6g35bvw';

  return (
    <>
      <div className={styles.headerContainer}>
        <Heading size={1} sectionHeader flushSpace>
          Voucher Portal
        </Heading>
        <Button size='md' Elem='a' href={surveyUrl} target='_blank'>
          <Icon InlineIcon={IconChat} /> Share your feedback
        </Button>
      </div>
      <VoucherListProvider>
        <BatchUpdateProvider>
          <VoucherList />
        </BatchUpdateProvider>
      </VoucherListProvider>
    </>
  );
};

export default Dashboard;
